import React from 'react';
import { Link } from 'react-router-dom';
import useLatestReportPath from 'hooks/Meteorology/Weather/Overview/useLatestReportPath';
import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';
import './index.scss';

export default function LatestReportLink() {
  const { latestReportPath, isLoading } = useLatestReportPath();

  if (isLoading || latestReportPath === undefined) {
    return null;
  }

  return (
    <Link
      to={`/${latestReportPath}`}
      className="link-secondary text-decoration-none mb-4 latest-reports-link"
    >
      <Icon iconType="info" color={cssVar('text-accent')} />
      Clique aqui para acessar o
      <span className="fw-bold"> Latest Report</span>
    </Link>
  );
}
